import { styled } from '@ori-ui/mui';

export const StyledG = styled('g')(() => ({
  isolation: 'isolate',
}));

export const StyledRect = styled('rect')(() => ({
  fill: 'url(#linear-gradient)',
}));

export const StyledPath = styled('path')(({ theme }) => ({
  fill: theme.palette.common.white,
}));
